import { Box, Button, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { APIDataUrl, APITokenUrl } from '../../Utils/Utils';
import axios from 'axios';
import { toast } from 'react-toastify';

const DeepSearchTableModal = ({ openTableModal, setOpenTableModal,
    selectedValue, tableData, setTableData, handleOrgCancel, placeholderId,
    setPlaceholderId, setLoading }) => {

    const style2 = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "80vw",
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const [openMessageModal, setOpenMessageModal] = useState(false)
    const updateExternalId = async (id) => {
        setLoading(true)
        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            url: `${APIDataUrl()}/v1/data_service/deep_search/update_external_id?request_id=${placeholderId}&external_id=${id}`,
        };
        try {
            const response = await axios(options);
            if (response?.data?.message === "External ID updated successfully") {
                setOpenTableModal(false); setTableData([]); handleOrgCancel(); setPlaceholderId("")
                setOpenMessageModal(true)
            } else {
                toast.error("Import request can nont be completed.Please try again.")
            }
            setLoading(false)

            handleOrgCancel()
        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.message);
        } finally {
        }
    }
    return (
        <>
            <Modal
                open={openTableModal}
                // onClose={() => { setOpenOrgAdvanceSearch(false) }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="advance-search-modal">
                    <Box sx={style2} style={{ overflowY: "auto", overflowX: "hidden" }}>
                        <h3 className='adv-search-modal red-search adv-table-head'>Deep Search<CloseIcon onClick={handleOrgCancel} /></h3>
                        <div className="de_pad-org-adv-search">
                            <TableContainer component={Paper} className="ai-leads-table-main-adv">
                                <Table aria-label="collapsible table" className="ai-leads-table">
                                    <TableHead>
                                        {
                                            selectedValue === "Organization" ?
                                                <TableRow className="table-row-ai-leads">
                                                    <TableCell className="score-row-table">Organization Name</TableCell>
                                                    <TableCell className="score-row-table">Website URL</TableCell>
                                                    <TableCell className="score-row-table">Industry</TableCell>
                                                    <TableCell className="score-row-table">City</TableCell>
                                                    <TableCell className="score-row-table">State</TableCell>
                                                    <TableCell className="score-row-table">Country</TableCell>
                                                    <TableCell className="score-row-table">Linkedin Url</TableCell>
                                                    <TableCell className="score-row-table"></TableCell>
                                                </TableRow> :
                                                <TableRow className="table-row-ai-leads">
                                                    <TableCell className="score-row-table">Full Name</TableCell>
                                                    {/* <TableCell className="score-row-table">Last Name</TableCell> */}
                                                    {/* <TableCell className="score-row-table">Email</TableCell> */}
                                                    <TableCell className="score-row-table">Job Title</TableCell>
                                                    <TableCell className="score-row-table">Organization</TableCell>
                                                    <TableCell className="score-row-table">Linkedin URL</TableCell>
                                                    <TableCell className="score-row-table"></TableCell>
                                                </TableRow>
                                        }

                                    </TableHead>
                                    <TableBody>
                                        {
                                            tableData?.map((item, index) => (
                                                <>
                                                    {
                                                        selectedValue === "Organization" ?
                                                            <TableRow>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.name || "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.website || "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.industry || "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.locality || "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.region || "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.country || "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.linkedin_url || "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className='de_btn_cont'>
                                                                        <Button className='de_next' onClick={() => updateExternalId(item?.data?.id)}>Import</Button>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow> :
                                                            <TableRow>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.full_name ? item?.data?.full_name : "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                {/* <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                <div className="enrich-table-content">
                                                                    <p>{item?.data?.last_name ? item?.data?.last_name : "-"}</p>
                                                                </div>
                                                            </TableCell> */}
                                                                {/* <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.email ? item?.data?.email : "-"}</p>
                                                                    </div>
                                                                </TableCell> */}
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.job_title ? item?.data?.job_title : "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        <p>{item?.data?.job_company_name ? item?.data?.job_company_name : "-"}</p>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className="enrich-table-content">
                                                                        {/* <p>{item?.data?.linkedin_url ? item?.data?.linkedin_url : "-"}</p> */}
                                                                        <p style={{textTransform:'lowercase'}}>
                                                                            {item?.data?.linkedin_url ? (
                                                                                <a
                                                                                    href={`https://${item.data.linkedin_url}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {`https://${item.data.linkedin_url}`}
                                                                                </a>
                                                                            ) : "-"}
                                                                        </p>

                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                                    <div className='de_btn_cont'>
                                                                        <Button className='de_next' onClick={() => updateExternalId(item?.data?.id)}>Import</Button>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>}
                                                </>
                                            ))
                                        }

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="de_hr">
                                <div className='de_btn_cont'>
                                    <Button className='de_cancel' onClick={() => { setOpenTableModal(false); setTableData([]); setPlaceholderId(""); handleOrgCancel() }} >Cancel</Button>
                                    <Button className='de_cancel' onClick={() => { setOpenTableModal(false); setTableData([]); setPlaceholderId(""); }}>Back</Button>
                                    <Button className='de_next' onClick={() => { setOpenTableModal(false); setTableData([]); handleOrgCancel(); setPlaceholderId(""); }}>Close</Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>

            <Modal
                open={openMessageModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto" }}>
                        <div className="de_pad">
                            <h3>The import process is successfully started. You will receive a notification when ready.</h3>
                            <div className="de_hr">
                                <div className='de_btn_cont'>
                                    <Button className="de_next" onClick={() => setOpenMessageModal(false)}>
                                        Close
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>
        </>
    )
}

export default DeepSearchTableModal
